<template>
  <div
    :class="['location-meta', `location-${location.id}`, {editable:isEditable}, {disabled:location.disabled}, {dragging:dragging}]"
    @click="$emit('singleClick')"
    v-toggle-select    
    v-on-clickaway="deselect"
  >
      <img class="meta-logo" src="../../../static/satsuma-logo-black.svg" alt="Satsuma Café">
      <h2>{{ location.title.rendered }}</h2>
      <div>
        <editable-text
          tag="span"
          v-if="location.acf.location_address1"
          :content="location.acf.location_address1"
          :editable="isEditable"
          @update="location.acf.location_address1 = $event"
        />
        <editable-text
          tag="span"
          v-if="location.acf.location_address2"
          :content="location.acf.location_address2"
          :editable="isEditable"
          @update="location.acf.location_address2 = $event"
        />
        <editable-text
          tag="span"
          v-if="location.acf.location_address3"
          :content="location.acf.location_address3"
          :editable="isEditable"
          @update="location.acf.location_address3 = $event"
        />
      </div>
      <div>
        <editable-text
          tag="span"
          v-if="location.acf.location_city"
          :content="location.acf.location_city"
          :editable="isEditable"
          @update="location.acf.location_city = $event"
        /><span>,</span>
        <editable-text
          tag="span"
          v-if="location.acf.location_state"
          :content="location.acf.location_state"
          :editable="isEditable"
          @update="location.acf.location_state = $event"
        /><span>&nbsp;</span>
        <editable-text
          tag="span"
          v-if="location.acf.location_zip"
          :content="location.acf.location_zip"
          :editable="isEditable"
          @update="location.acf.location_zip = $event"
        />
        
      </div>
      <editable-text
        tag="p"
        v-if="location.acf.location_menu_blurb"
        :content="location.acf.location_menu_blurb"
        :editable="isEditable"
        @update="location.acf.location_menu_blurb = $event"
      />
      <div class="contact-info">
        <span>satsumacafe.com</span>
        <editable-text
          tag="span"
          v-if="location.acf.location_phone"
          :content="location.acf.location_phone"
          :editable="isEditable"
          @update="location.acf.location_phone = $event"
        />
        <br>
        <b>
          <editable-text
            tag="span"
            v-if="location.acf.location_hours"
            :content="location.acf.location_hours"
            :editable="isEditable"
            @update="location.acf.location_hours = $event"
          />
        </b>

      </div>

      <transition name="fade">
        <div class="button-cluster" v-if="isEditable">
          <button class="save" @click="saveLocation">Save</button>
          <button @click.stop="deselect">Stop Editing</button>
        </div>
      </transition>

  </div>

</template>

<script>

import ToggleSelect from '../../toggle-select'

import EditableTextField from '../EditableTextField'
import VueClickaway from 'vue-clickaway'
import axios from 'axios'

import { mapState, mapGetters } from 'vuex'

export default {

  name: 'LocationMeta',
  mixins : [ VueClickaway.mixin, ToggleSelect ],  
  props : [
    'location',
  ],
  components : {
    'editable-text' : EditableTextField
  },
  computed : {
    isEditable() {
      return !this.disabled && this.selected && this.isAuthenticated;
    },
    ...mapState(['wpData','authToken']),
    ...mapState(['isAuthenticated'])
  },
  methods: {

    saveLocation() {
      let location_id = this.location.id;

      this.$notify(`Saving single Location [${location_id}]..`);

      this.$store.dispatch('authPromise').then( authToken => {

        let acfFields = { fields : this.location.acf };
        return axios.put(
          `${this.wpData.rest_url}/acf/v3/${this.wpData.cpts.locations}/${location_id}`,
          acfFields,
          { headers : {'Authorization' : `Bearer ${this.authToken}`} }
        ).then( res => {
          this.$notify(`ACF Updated for ${location_id}`);
          console.log(`[ACF Updated for ${location_id}]`,res)
          return res;
        });      

      });      
    }, // saveLocation()


  }, // methods
  data () {
    return {
      dragging : false
    }
  }
}
</script>

<style lang="scss">

$gutter:60px;

.location-meta {
  // transition: background-color .3s ease, opacity .3s ease, box-shadow .3s ease, position .3s ease;
  transition: all .3s ease;
  text-align:center;
  padding:100px 40px;
  box-shadow:none;
  opacity:1;
  padding:40px $gutter;
  position: relative;
  flex:1 0 calc(30% - #{$gutter*2});  
  min-width:400px;
  // display:flex;
  // align-items:flex-start;

  &.editable {
    box-shadow:0 7px 24px -2px rgba(0, 0, 0, 0.5);
    transform: translateY(-10px);
    .section, .item, .addon {
      transition: background-color .3s ease;      
      &:hover {
        // box-shadow:0 7px 24px -2px rgba(0, 0, 0, 0.5)
        // background-color:rgba(0,0,0,.1);
      }
    }
  }

  &.disabled {
    opacity:.2;
  }

  &.dragging {
    .empty{
      align-self: stretch;
      &:after {
        background-color:rgba(black, .05);
        content:'';
        position:absolute;
        $padding:10px;
        padding:$padding;
        left:-$padding;
        top:-$padding;
        width:100%;
        height:100%;
      }
    }

  }
  &:not(.selected) {
    cursor:pointer;
    &:hover {
      background:rgba(138, 251, 109, 0.2);
    }
  }  
  p {
    font-size:.9rem;
  }
} // .location-meta

.meta-logo {
  height:250px;
  width:auto;
  padding:20px 40px;
  border-bottom:4px solid black;
}
.location-meta .button-cluster {
  position:absolute;
  bottom:20px;right:20px;
}

.dynamic-content[contenteditable="true"] {
  $activeBgColor : #00c2ff;
  outline:none;
  // &:before,
  &:after {
    background-color:$activeBgColor;
  }
}  
</style>


// WEBPACK FOOTER //
// src/components/Location/LocationMeta.vue